<template>
    <div class="row">
        <div class="col-5 text-left row-left">
            <slot name="left"/>
        </div>

        <div class="col-2 text-center row-center">
            <slot name="center"/>
        </div>

        <div class="col-5 text-right row-right">
            <slot name="right"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'touchpoint-overview-row'
    }
</script>
